// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"8b600499","229":"9e18c479","545":"6926921a","776":"1f52e5c0"}[chunkId] + ".chunk.css";
};